import { axiosApi } from "./helper";

export default function searchRequest(search, filters, sort) {
  const obj = {
    search,
    sort,
    ...filters,
  };

  return axiosApi("search", obj, "get");
}
